import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dimensionMetricsSelector, dimensionsSelector } from '@store/trends/base/selectors';
import {
  setDimensions,
  removeDimension as removeTrendsDimension,
  updateDimension as updateTrendsDimension,
} from '@store/trends/base/actions';
import { tableMetricsAtom } from '@src/components/dimension-panel-hz/atoms';

export interface DimensionOperations {
  selectedDimensions: string[];
  setSelectedDimensions: (dimensions: string[]) => void;
  removeDimension: (dimension: string) => void;
  updateDimension: (dimension: string, newDimension: string) => void;
  dimensionMetrics: string[];
  orderedDimensionMetrics: {
    metrics: string[];
    orderBy: string;
  };
}

export function useDimensionOperations() {
  const selectedDimensions = useSelector(dimensionsSelector);
  const dispatch = useDispatch();
  const setSelectedDimensions = useCallback(
    (dimensions: string[]) => {
      dispatch(setDimensions(dimensions));
    },
    [dispatch],
  );
  const removeDimension = useCallback(
    (dimension: string) => {
      dispatch(removeTrendsDimension(dimension));
    },
    [dispatch],
  );

  const updateDimension = useCallback(
    (dimension: string, newDimension: string) => {
      dispatch(updateTrendsDimension(dimension, newDimension));
    },
    [dispatch],
  );

  const dimensionMetrics = useSelector(dimensionMetricsSelector);
  const { metrics, orderBy }: any = useAtomValue(tableMetricsAtom);

  return {
    selectedDimensions,
    setSelectedDimensions,
    removeDimension,
    updateDimension,
    dimensionMetrics,
    orderedDimensionMetrics: {
      metrics,
      orderBy,
    },
  } as DimensionOperations;
}
